import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {selectLandingType, selectPlan, selectShowCheckout, setCheckoutVisited, setShowCheckout} from './plansSlice';
import {selectEventsData, setAnalyticsData, setEventDataList} from '../events/eventsSlice';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import Slider from './Slider';
import DefaultPlans from './DefaultPlans';
import { centeredFlex, fadeInAnimation, screenPadding } from '../../mixins';
import UIButton from '../../UI/UIButton';
import { isBrowser } from 'react-device-detect';
import ExperimentalPlans from './ExperimentalPlans';
import { selectStripeAccountName } from '../signup/signupSlice';
import { PLANS } from '../../analytics/eCommerce';
import {useAnalyticsData} from '../checkout/helper';


const StyledContainer = styled.div`
    ${centeredFlex};
    ${screenPadding};
    ${isBrowser && fadeInAnimation};
    min-height: 100%;
    justify-content: flex-end;
    position: relative;
    @media screen and (max-width: 430px) {
        justify-content: flex-start;
    }
    
    @media screen and (min-width: 768px) {
        // height: calc(100vh - 116px);
        // min-height: unset;
    }
`;

const PlansScreen = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const amplitudeEventsData = useSelector(selectEventsData);
    const landingType = useSelector(selectLandingType);
    const stripeAccountName = useSelector(selectStripeAccountName)
    const plan = useSelector(selectPlan);
    const defaultPlans = [
        'fullPrice',
        'option_b',
        'option_b2',
        'option_c',
        'discountb',
    ];
    const isDefault = defaultPlans.includes(landingType);
  const analyticsParams = useAnalyticsData();
  const showCheckout = useSelector(selectShowCheckout)

  useEffect(() => {
    dispatch(setAnalyticsData(analyticsParams))
  },[analyticsParams, dispatch]);

    useEffect(() => dispatch(setCheckoutVisited(true)), [dispatch]);

    useEffect(() => {
      !showCheckout &&
        sendAnalyticsEvents(EVENTS.plansScreenShown, amplitudeEventsData);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCheckout]);

    const handleSetAmplitudeEvents = () => {
      if (!plan) return
      const { productId, duration, description, periodPrice: price } = PLANS[plan]

      let localEventsData = {
        value: price * 100,
        currency: 'USD',
        price: price,
        description: description,
        periodPrice: price,
        product_id: productId,
        duration: duration,
        stripe_account_name: stripeAccountName,
      }
      dispatch(setEventDataList(localEventsData))
    }
    const onBuyClick = () => {
      handleSetAmplitudeEvents()
      dispatch(setShowCheckout(true))
    }


    return (
        <StyledContainer>
            {isDefault
                ? <>
                    <Slider />
                    <DefaultPlans />
                    <UIButton onClick={onBuyClick}>{t('continue')}</UIButton>
                </>
                : <ExperimentalPlans onBuyClick={onBuyClick}/>
            }
        </StyledContainer>
      )
    
};


export default PlansScreen;